import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandConversionJourney {
    async run(affiliateId: String, startDate: String, endDate: String, launchSelected: String, timePeriodSelected: String) {  
        const path = `get-chart-data/client:conversion-journeys/?affiliate_id=${affiliateId}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            return response
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

